// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-mediumOnWide-badge-a5fbb265"};